module.exports = __webpack_public_path__ + "img/feature_buy_zh.17ba3488.png";